import { createContext, useCallback, useContext } from 'react';
import { deviceHref, LEGACY_DEVICE_BASE, type DeviceTabId } from './deviceDetail';

/**
 * WHERE A DEVICE LINK POINTS, decided by the page it is rendered on.
 *
 * `deviceHref()` still points at the legacy `/pos-config/fleet/:id` (Task 30
 * owns the global switch). Fleet Monitoring wraps its content in
 * `<DeviceLinkBase.Provider value={FLEET_MONITORING_DEVICE_BASE}>` so the same
 * FleetTable / DeviceHealthPanel link straight to its own device pages — a
 * role holding only `/fleet-monitoring` never bounces through a legacy URL.
 */
export const FLEET_MONITORING_DEVICE_BASE = '/fleet-monitoring/devices';

export const DeviceLinkBase = createContext<string>(LEGACY_DEVICE_BASE);

export function useDeviceHref(): (deviceId: string, tab?: DeviceTabId, deviceType?: string) => string {
  const base = useContext(DeviceLinkBase);
  return useCallback((deviceId, tab, deviceType) => deviceHref(deviceId, tab, deviceType, base), [base]);
}
